import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgTrophy = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M5.75 5.25V10.4156C5.75 14.1375 8.73125 17.2219 12.4531 17.25C13.3435 17.2562 14.2263 17.0862 15.0506 16.7497C15.875 16.4133 16.6247 15.917 17.2564 15.2896C17.8882 14.6622 18.3896 13.916 18.7317 13.094C19.0739 12.272 19.25 11.3904 19.25 10.5V5.25C19.25 5.05109 19.171 4.86032 19.0303 4.71967C18.8897 4.57902 18.6989 4.5 18.5 4.5H6.5C6.30109 4.5 6.11032 4.57902 5.96967 4.71967C5.82902 4.86032 5.75 5.05109 5.75 5.25Z"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.5 21H15.5"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.5 17.25V21"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.0814 12H20.0002C20.7958 12 21.5589 11.6839 22.1215 11.1213C22.6841 10.5587 23.0002 9.79565 23.0002 9V7.5C23.0002 7.30109 22.9212 7.11032 22.7805 6.96967C22.6398 6.82902 22.4491 6.75 22.2502 6.75H19.2502"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.93796 12H4.99109C4.19544 12 3.43238 11.6839 2.86977 11.1213C2.30716 10.5587 1.99109 9.79565 1.99109 9V7.5C1.99109 7.30109 2.07011 7.11032 2.21076 6.96967C2.35141 6.82902 2.54218 6.75 2.74109 6.75H5.74109"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgTrophy.displayName = 'SvgTrophy';
export default SvgTrophy;
